const MuiLink = {
  /** DEFAULT PROPS */
  defaultProps: { underline: 'hover' },

  /** STYLE */
  styleOverrides: {
    root: {
      gap: 8,
      cursor: 'pointer',
      alignItems: 'center',
      display: 'inline-flex',
    },
  },
};

export const link = { MuiLink };
